import styled from 'styled-components';
import {Box, IBoxProps, mediaQueries } from '@lce/slice';

import SvgPriceSymbol from './assets/price-symbol.svg';
import SvgPriceSymbolAskterisk from './assets/price-symbol-astkterisk.svg';

interface IPriceSymbolProps extends IBoxProps {
  isCentered: boolean;
}

export const PriceSymbol = styled(Box)<IPriceSymbolProps>`
  ${ props => props.isCentered ? `
    position: relative;
    top: -0.3em;
    margin-left: 0.25rem;
    ` : `
    align-self: flex-start;
    ` }

  flex: 0 1 2.25rem;
  width: 28px;
  height: auto;
  color: inherit;

  ${mediaQueries[2]} {
    width: 36px;
  }
`;

export const PriceSvg = styled(SvgPriceSymbol)`
  fill: currentColor;
  width: 100%;
`;

export const PriceSvgAskterisk = styled(SvgPriceSymbolAskterisk)`
  fill: currentColor;
  width: 100%;
`;
